import React, { useContext } from "react";
import { NavLink} from 'react-router-dom';

import Link from '@mui/material/Link';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LoginIcon from '@mui/icons-material/Login';
import { deepPurple } from '@mui/material/colors';

import {NestedMenuItem} from 'mui-nested-menu';

import AuthContext from "../context/AuthContext";
import * as Security from '../../utils/auth/Security';



const ResponsiveAppBar = (props) => {
    const [anchorElAdminSys, setAnchorElAdminSys] = React.useState(null);
    const [anchorElAdminDate, setAnchorElAdminDate] = React.useState(null);
    const [anchorElRsvti, setAnchorElRsvti] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const authContext = useContext(AuthContext);

    const handleOpenAdminSys = (event) => setAnchorElAdminSys(event.currentTarget);
    const handleCloseAdminSys = () => setAnchorElAdminSys(null);

    const handleOpenAdminDate = (event) => setAnchorElAdminDate(event.currentTarget);
    const handleCloseAdminDate = () => setAnchorElAdminDate(null);

    const handleOpenRsvti = (event) => setAnchorElRsvti(event.currentTarget);
    const handleCloseRsvti = () => setAnchorElRsvti(null);


    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleLogout = () => {
        props.logoutUser();
        handleCloseUserMenu();
    }

    var avatarLetters = '';
    if (authContext.isAuthenticated && authContext.afUser) {
        avatarLetters = authContext.afUser?.generalSection?.firstName?.charAt(0) + authContext.afUser?.generalSection?.lastName?.charAt(0);
    }


    return (
        <AppBar position="static">
            <Container maxWidth="xl">

                <Toolbar>
                    {/* <Link href="/" color="inherit">
                        <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1, ml: 2 }} />
                    </Link> */}
                    <Link href="/" color="inherit">
                        <Box
                            component="img"
                            sx={{
                                height: 30,
                                // width: 30,
                                maxHeight: { xs: 24, md: 24 },
                                // maxWidth: { xs: 30, md: 30 },
                            }}
                            alt="The house from the offer."
                            src="/assets/images/red white.png"
                        />
                    </Link>
                    <Typography
                        variant="h4"
                        noWrap
                        component="div"
                        sx={{ flexGrow: 1, mr: 1 }}
                    >
                        AngelFlow
                    </Typography>
                </Toolbar>

                <Toolbar >
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {/* <Button
                            key="home"
                            sx={{ my: 2, color: 'white', display: 'block', ml: 3 }}
                        >
                            <NavLink className="nav-link" to='/home'>Acasa</NavLink>
                        </Button> */}

                        {!authContext.isAuthenticated ?
                            <React.Fragment></React.Fragment>
                            :
                            <React.Fragment>

                                {/************************** Home Section ***************************/}
                                <Button
                                    key="home"
                                    sx={{ my: 2, color: 'white', display: 'block', ml: 3 }}
                                >
                                    <NavLink className="nav-link" to='/home'>Acasa</NavLink>
                                </Button>


                                {/************************** Admin System Section ***************************/}
                                {Security.isUserAuthorizedForPath('ADMIN-SYS-GROUP') &&
                                    <React.Fragment>
                                        <Button
                                            key="adminsys"
                                            onClick={handleOpenAdminSys}
                                            sx={{ my: 2, color: 'white' }}
                                        >
                                            Admin System<ExpandMoreIcon />
                                        </Button>
                                        <Menu
                                            id="menu-adminsys"
                                            anchorEl={anchorElAdminSys}
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                            open={Boolean(anchorElAdminSys)}
                                            onClose={handleCloseAdminSys}
                                        >
                                            {Security.isSystemUser() ?
                                                <div>
                                                    <MenuItem key="clients" onClick={handleCloseAdminSys}>
                                                        <NavLink className="nav-link" to='/clients'>Clienti</NavLink>
                                                    </MenuItem>
                                                    <MenuItem key="usersClients" onClick={handleCloseAdminSys}>
                                                        <NavLink className="nav-link" to='/users'>Utilizatori Clienti</NavLink>
                                                    </MenuItem>
                                                    <MenuItem key="utilizatoriCorEvo" onClick={handleCloseAdminSys}>
                                                        <NavLink className="nav-link" to='/sysusers'>Utilizatori CorEvo</NavLink>
                                                    </MenuItem>
                                                </div>
                                                :
                                                <div>
                                                    <MenuItem key="myClient" onClick={handleCloseAdminSys}>
                                                        <NavLink className="nav-link" to='/myclient'>Client</NavLink>
                                                    </MenuItem>
                                                    <MenuItem key="users" onClick={handleCloseAdminSys}>
                                                        <NavLink className="nav-link" to='/users'>Utilizatori</NavLink>
                                                    </MenuItem>
                                                </div>
                                            }
                                        </Menu>
                                    </React.Fragment>
                                }


                                {/************************** Admin Date Section ***************************/}
                                <Button
                                    key="admindate"
                                    onClick={handleOpenAdminDate}
                                    sx={{ my: 2, color: 'white', display: 'block' }}
                                >
                                    Admin Date<ExpandMoreIcon />
                                </Button>
                                <Menu
                                    id="menu-admindate"
                                    anchorEl={anchorElAdminDate}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                    open={Boolean(anchorElAdminDate)}
                                    onClose={handleCloseAdminDate}
                                >
                                    <MenuItem key="employers" onClick={handleCloseAdminDate}>
                                        {Security.isUserOfClientEmployer() ?
                                            <NavLink className="nav-link" to='/myemployer'>Angajator</NavLink>
                                                :
                                            <NavLink className="nav-link" to='/employers'>Angajatori</NavLink>
                                        }
                                    </MenuItem>
                                    <MenuItem key="employees" onClick={handleCloseAdminDate}>
                                        <NavLink className="nav-link" to='/employees'>Deserventi</NavLink>
                                    </MenuItem>
                                    <MenuItem key="equipment" onClick={handleCloseAdminDate}>
                                        <NavLink className="nav-link" to='/equipment'>Instalatii</NavLink>
                                    </MenuItem>
                                </Menu>

                                {/************************** RSVTI Section ***************************/}
                                <Button
                                    key="rsvti"
                                    onClick={handleOpenRsvti}
                                    sx={{ my: 2, color: 'white', display: 'block' }}
                                >
                                    InfoFlux<ExpandMoreIcon />
                                </Button>
                                <Menu
                                    id="menu-rsvti"
                                    anchorEl={anchorElRsvti}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                    open={Boolean(anchorElRsvti)}
                                    onClose={handleCloseRsvti}
                                >
                                    <MenuItem key="reminder-calenda-deserventi" onClick={handleCloseRsvti}>
                                        <NavLink className="nav-link" to='/deserventi-calendar'>Calendar Reminder</NavLink>
                                    </MenuItem>

                                    <NestedMenuItem
                                        sx={{ ml: '0px', pl: '8px' }}
                                        rightIcon={<KeyboardArrowRightIcon />}
                                        label="RSVTI"
                                        parentMenuOpen={Boolean(anchorElRsvti)}
                                    >

                                        <MenuItem key="deserventi-tasks" onClick={handleCloseRsvti}>
                                            <NavLink className="nav-link" to='/rsvti/deserventi/tasks'>Deserventi</NavLink>
                                        </MenuItem>

                                        <MenuItem key="deserventi-inst" onClick={handleCloseRsvti}>
                                            <NavLink className="nav-link" to='/rsvti/equipment'>Instalatii</NavLink>
                                        </MenuItem>

                                        <MenuItem key="reports" onClick={handleCloseRsvti}>
                                            <NavLink className="nav-link" to='/rsvti/reports'>Rapoarte</NavLink>
                                        </MenuItem>
                                    </NestedMenuItem>

                                    {/* <NestedMenuItem
                                        sx={{ ml: '0px', pl: '8px' }}
                                        rightIcon={<KeyboardArrowRightIcon />}
                                        label="SSM/PSI"
                                        parentMenuOpen={Boolean(anchorElRsvti)}
                                    >

                                        <MenuItem key="tasks-deserventi" onClick={handleCloseRsvti}>
                                            <NavLink className="nav-link" to='/psitask'>Tasks</NavLink>
                                        </MenuItem>
                                    </NestedMenuItem> */}
                                </Menu>

                            </React.Fragment>
                        }

                        {/* <Button
                            key="aboutus"
                            //                onClick={handleCloseAdminDate}
                            sx={{ my: 2, color: 'white', display: 'block' }}
                        >
                            <NavLink className="nav-link" to='/aboutus'>Despre Noi</NavLink>
                        </Button>

                        <Button
                            key="contactus"
                            //                onClick={handleCloseNavMenu}
                            sx={{ my: 2, color: 'white', display: 'block' }}
                        >
                            <NavLink className="nav-link" to='/contactus'> Contact</NavLink>
                        </Button> */}

                    </Box>

                    {/************************** Login / Logout Section ***************************/}
                    {!authContext.isAuthenticated ?

                        <NavLink className="nav-link" to="/login">
                            <Button key="signIn" variant="contained" startIcon={<LoginIcon />} sx={{ bgcolor: '#3f51b5', '&:hover': { bgcolor: '#5c6bc0' } }}>
                                Login
                            </Button>
                        </NavLink>
                        :
                        <Box sx={{ flexGrow: 0 }}>
                            <Tooltip title="Open settings">
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    <Avatar sx={{ bgcolor: deepPurple[500] }} >{avatarLetters}</Avatar>
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                <MenuItem key="profile-key" onClick={handleCloseUserMenu}>
                                    <NavLink className="nav-link" to='/myaccount/profile'>Profilul meu</NavLink>
                                </MenuItem>
                                <MenuItem key="logout-key" onClick={handleLogout}>
                                    <NavLink className="nav-link" to='/home'>Logout</NavLink>
                                </MenuItem>

                            </Menu>
                        </Box>
                    }
                </Toolbar>
            </Container>
        </AppBar>
    );
};


function Header(props) {

    return (
        <React.Fragment>

            <ResponsiveAppBar logoutUser={props.logoutUser} />

        </React.Fragment>
    );
}

export default Header;